<script>  
  export let closeVisible;
  export let backVisible;
  export let className;

  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  const handleCloseClick = () => {
    if (!closeVisible) { return; }
    dispatch('requestclose');
  }

  const handleBackClick = () => {
    if (!backVisible) { return; }
    dispatch('requestback');
  }
</script>

<style>
.container {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: black;
    z-index: 100;    
    overflow: hidden;

    overflow: auto;
    -ms-overflow-style: none;
}

.closeIcon {
  z-index: 100;
  position: fixed;
  right: 10px;
  top: 10px;
  cursor: pointer;
  fill: white;
  transition: fill 0.5s ease-in-out, opacity 0.5s ease-in-out;
}
.closeIcon:hover {
  fill: #ffc107;
}

.backIcon {
  z-index: 100;
  position: fixed;
  left: 10px;
  top: 10px;
  cursor: pointer;
  fill: white;
  transition: fill 0.5s ease-in-out, opacity 0.5s ease-in-out;
}
.backIcon:hover {
  fill: #ffc107;
}
</style>


<div class="container {className}">
	<slot></slot>
</div>

<svg 
  class="closeIcon"
  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
  width="70" height="70"
  viewBox="0 0 50 50"
  style="opacity: {closeVisible ? 1 : 0}; pointer-events: {closeVisible ? "auto" : "none"}"
  on:click={handleCloseClick}
>
  <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M34.71,33.29l-1.42,1.42 L25,26.42l-8.29,8.29l-1.42-1.42L23.58,25l-8.29-8.29l1.42-1.42L25,23.58l8.29-8.29l1.42,1.42L26.42,25L34.71,33.29z"></path>
</svg>

<svg 
  class="backIcon"
  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
  width="70" height="70"
  style="opacity: {backVisible ? 1 : 0}; pointer-events: {backVisible ? "auto" : "none"}"
  on:click={handleBackClick}
  viewBox="0 0 50 50"
>
<path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z    M 38 26 L 20 26 L 20 32 L 13 25 L 20 18 L 20 24 L 38 24 Z"></path></svg>
